import { styled, Button, Grid } from '../../../base';

export const StyledFilterBar = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2, 3),
    alignItems: 'center',
}));

export const StyledFilterItem = styled(Grid)({
    position: 'relative',
});

export const StyledAddFilterButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    ...theme.typography.caption,
    borderRadius: theme.shape.borderRadius,
    paddingInline: theme.spacing(4),
    minHeight: 40,
    '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
    },
}));
